export default from './UpdatePasswordForm';



// WEBPACK FOOTER //
// ./src/components/BuyerSettings/components/UpdatePasswordForm/index.js